<template>
  <v-hover v-slot="{ hover }" open-delay="0">
    <v-card
      @click="itemClick(item)"
      :style="{ backgroundColor: getBackgroundColor(item.limit_data, type) }"
      style="position:relative; border: solid 1px #B0BEC5;"
      :elevation="hover ? 16 : 2"
      :class="{ 'on-hover': hover, 'pt-5': type == 'card', 'pt-1': type == 'deck'}"
      class="ma-1 pb-2 d-flex flex-wrap"
    >
      <div class="pa-1">
        <!-- ショートコードコピー_S -->
        <div
          v-if="type == 'deck'"
          class="button_label_noimg white ml-1 mr-1 mt-1 mb-1"
          style="border: 2px solid #F44336 !important; color: #F44336 !important; border-radius: 10px;"
          @click="itemCopy2(item)"
        >
          <span>
            <v-icon color="red darken-1" size="18">mdi-alpha-s-box-outline</v-icon>ｼｮｰﾄｺｰﾄﾞ
          </span>
        </div>
        <!-- ショートコードコピー_E -->
        <!-- カード/デッキ画像_S -->
        <div
          style="position: relative; width:100px!important; margin-left: auto; margin-right: auto;"
        >
          <v-img
            v-if="type == 'card'"
            width="100"
            height="145"
            :src="'https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/'+item.id+'.webp'"
            style="outline: 1px solid #a9a9a9; border-radius: 2px;"
          ></v-img>
          <v-img
            v-if="type == 'deck' && item.img != ''"
            width="100"
            height="145"
            :src="'https://appmedia.jp'+item.img"
            style="outline: 1px solid #a9a9a9; border-radius: 2px;"
          ></v-img>
          <v-img
            v-if="type == 'deck' && item.img == ''"
            width="100"
            height="145"
            src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/img/all_cards/no_image.webp"
            style="outline: 1px solid #a9a9a9; border-radius: 2px;"
          ></v-img>
          <div
            v-if="type == 'deck'"
            class="pa-1"
            width="100"
            height="100"
            style="
            position: absolute; 
            bottom: 5px; 
            right: 5px; 
            background-color: #fff; 
            border-radius: 10px; 
            border: 1px solid #222; 
            display: inline-flex;"
          >
            <v-img
              loading="lazy"
              src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/other/master_duel_deck.webp"
              width="30"
            ></v-img>
          </div>

          <v-img
            v-if="type == 'card' && item.limit_data == '禁止'"
            loading="lazy"
            src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/other/kinshi.png"
            width="25"
            height="25"
            style="position: absolute; top:0px; left:0px; background-color: #222; border-radius: 30px;"
          ></v-img>
          <div v-if="type == 'card' && item.limit_data == 'リミット1'" class="limit">1</div>
          <div v-if="type == 'card' && item.limit_data == 'リミット2'" class="limit">2</div>
          <div v-if="type == 'card' && item.limit_data == 'リミット3'" class="limit">3</div>
          <div v-if="type == 'card' && item.legend == 'LEGEND'" class="legend">L</div>
        </div>
        <!-- <img
          v-if="type == 'card' && item.legend == 'LEGEND'"
          loading="lazy"
          src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/other/rush_legend.webp"
          width="80px"
          height="auto"
          style="position: absolute; top:3px; left:0px;"
        >-->
        <!-- カード/デッキ画像_E -->

        <div
          @click="editItem(item)"
          :style="{ color: getTextColor(item.limit_data, type) }"
          style="font-weight: bold; text-shadow: 1px 1px 2px #BDBDBD;"
          class="card_name mt-2 pl-2 pr-2"
        >{{ item.name }}</div>

        <!-- aタグコピー_S -->
        <div class="mt-2">
          <div
            class="button_label_img white ml-1 mr-1"
            style="border: 2px solid #F44336 !important; color: #F44336 !important; border-radius: 10px;"
            @click="itemCopy(item, 'img')"
          >
            <span>
              <v-icon color="red darken-1" size="15">mdi-image-outline</v-icon>画像あり
            </span>
          </div>
          <div
            class="button_label_noimg white ml-1 mr-1 mt-1"
            style="border: 2px solid #F44336 !important; background-color: #F44336 !important; color: #fff !important; border-radius: 10px;"
            @click="itemCopy(item, '')"
          >
            <span>
              <v-icon color="white" size="15">mdi-image-off</v-icon>画像なし
            </span>
          </div>
        </div>
        <!-- aタグコピー_E -->
      </div>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  // item配列受け取り
  props: {
    item: Object,
    type: String
  },

  methods: {
    // リミットに応じてカードの背景色変更
    getBackgroundColor(limit, type) {
      var color = "";
      if (type == "deck") {
        return "white";
      }
      if (limit == "") {
        color = "white";
      } else if (limit == "リミット3") {
        color = "rgb(143 212 255)";
      } else if (limit == "リミット2") {
        color = "#FFF9C4";
      } else if (limit == "リミット1") {
        color = "rgb(255 190 141)";
      } else if (limit == "禁止") {
        color = "#ff9c9c";
      }

      return color;
    },

    // リミットに応じてカード名文字色変更
    getTextColor(limit, type) {
      var color = "";
      if (type == "deck") {
        return "#212121";
      }

      if (limit == "") {
        color = "#212121";
      } else if (limit == "リミット3") {
        color = "rgb(0 97 157)";
      } else if (limit == "リミット2") {
        color = "#BF360C";
      } else if (limit == "リミット1") {
        color = "#795548";
      } else if (limit == "禁止") {
        color = "#bd0000";
      }

      return color;
    },

    // カード選択時
    // 呼び出し元に投げる
    itemClick(item) {
      if (this.$listeners["editItem"]) {
        this.$emit("editItem", item);
      }
    },

    // クリップボードにコピー
    // 呼び出し元に投げる
    itemCopy(item, img) {
      if (this.$listeners["editItem"]) {
        this.$emit("copyToClipboard", item, img);
      }
    },

    // クリップボードにコピー2
    // 呼び出し元に投げる(デッキのショートコード)
    itemCopy2(item, img) {
      if (this.$listeners["editItem"]) {
        this.$emit("copyToClipboard2", item, img);
      }
    }
  }
};
</script>

<style>
.card_img {
  outline: 1px solid #a9a9a9;
  border-radius: 2px;
}
.deck_list {
  display: flex;
  flex-wrap: wrap;
}
.deck_list li {
  display: inline-block;
  /* width: 12%; */
  text-align: center;
  font-size: 11px;
  line-height: 1.2;
  margin-bottom: 2px;
  margin-top: 2px;
}
.deck_list li .card_name {
  width: 150px;
}
.v-application .mt-2 {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 10px;
  font-weight: bold;
  margin-top: 3px !important;
}
.limit {
  border: 2px solid #ff0000;
  border-radius: 20px;
  width: 25px;
  height: 25px;
  background-color: #222;
  color: #ffff00;
  font-weight: bold;
  display: inline-block;
  text-align: center;
  font-size: 17px;
  margin-right: 2px;
  position: absolute;
  top: 0px;
  left: 0px;
}
.legend {
  border: 1px solid #222;
  border-radius: 20px;
  width: 20px;
  height: 20px;
  font-size: 15px;
  background-color: #ffff00;
  color: #222;
  font-weight: bold;
  display: inline-block;
  text-align: center;
  margin-right: 2px;
  position: absolute;
  top: 0px;
  right: 0px;
}
.button_label_noimg,
.button_label_img {
  font-size: 12px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.button_label_noimg2,
.button_label_img2 {
  font-size: 15px !important;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* .article_button {
  border: 2px solid #01579b !important;
  border-radius: 10px;
} */

.custom_textarea {
  font-size: 13px !important;
}
</style>